<template>
    <div>
		<div class="page-title">История выплат</div>
		<div class="table">
			<table>
				<thead>
					<tr>
						<th>Игрок</th>
						<th>Метод</th>
						<th>Реквизиты</th>
						<th>Сумма</th>
						<th>Время</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="wdw in wdws">
						<td>{{ wdw.username }}</td>
						<td>{{ wdw.system }}</td>
						<td>{{ wdw.wallet }}</td>
						<td>{{ $root.currency(wdw.amount) }}</td>
						<td class="nowrap">{{ wdw.date }}</td>
					</tr>
				</tbody>
			</table>
		</div>
    </div>
</template>

<script>
    import {mapState} from "pinia";
	import {useUserStore} from "../../stores/User.js";

	export default {
        data() {
            return {
                wdws: [],
                tableLength: 20,
            }
        },

		computed: {
			...mapState(useUserStore, ['user'])
		},


		methods: {
            fillTable() {
                this.$root.axios.get('/api/withdraw/latest')
                    .then(res => {
                        const data = res.data;
                        this.wdws = data;

                        this.$root.isLoading = false;
                    });
            },
        },
        beforeMount() {
            this.$root.isLoading = true;

            this.fillTable()
        }
    }
</script>
